import React from 'react';
import { Card } from './Card';
import { Legend } from '../Legend';
import { BarChart } from '../charts/BarChart';
import { ChartInput } from '../../model/ChartInput';
import { Information } from '../Information';
import { t } from '../../i18n';

const AgeCard = ({ input }: Props) => {
  // const childrenColor = '#EDE2FF';
  // const youngColor = '#FFA16C';
  // const middleColor = '#1ACBE6';
  // const elderColor = '#A162F7';
  // const datasets = [{ data: [ 10, 40, 20, 40 ], backgroundColor: [ childrenColor, youngColor, middleColor, elderColor ], barThickness: 20, borderRadius: 15, borderSkipped: false }];
  // const labels = ['<20', '21-40', '41-60', '>60'];
  return (
    <Card className="">
       <div className="card-body">
        <div className="row h-100">
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div className="d-flex align-items-center">
              <Information id="age" content={<h5 className="card-title mb-2 mb-lg-0">{t('cards.age')}</h5>} />
              <Information id="age" showMore={true} className="ms-2" />
            </div>
            <div className="d-lg-flex align-items-center h-100">
              <div className="d-lg-flex flex-lg-column mb-2 mb-lg-0 w-100">
                <Legend color={'label-primary'} label={t('age.Children (0-20)')} />
                <Legend color={'warning'} label={t('age.Young (21-40)')} />
                <Legend color={'info'} label={t('age.Middle Age (41-60)')} />
                <Legend color={'primary'} label={t('age.Elder (61-99)')} />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 order-1 order-lg-2">
            <BarChart datasets={input.datasets || []} labels={input.labels || []} displayGrid={false} displayY={false} />
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  input: ChartInput
}

export { AgeCard };